import app from '../../admin/app';
import Modal from '../../common/components/Modal';
const previewGroups = [{
  labelKey: 'core.admin.advanced.fontawesome.preview.fa5_fa6_label',
  icons: [{
    cls: 'fas fa-house',
    label: 'fas'
  }, {
    cls: 'far fa-envelope',
    label: 'far'
  }, {
    cls: 'fab fa-github',
    label: 'fab'
  }]
}, {
  labelKey: 'core.admin.advanced.fontawesome.preview.fa7_label',
  icons: [{
    cls: 'fa-solid fa-house',
    label: 'fa-solid'
  }, {
    cls: 'fa-regular fa-envelope',
    label: 'fa-regular'
  }, {
    cls: 'fa-brands fa-github',
    label: 'fa-brands'
  }, {
    cls: 'fas fa-bus-side',
    label: 'fa-bus-side'
  }]
}, {
  labelKey: 'core.admin.advanced.fontawesome.preview.pro_label',
  icons: [{
    cls: 'fal fa-house',
    label: 'Light'
  }, {
    cls: 'fat fa-house',
    label: 'Thin'
  }, {
    cls: 'fad fa-house',
    label: 'Duotone'
  }]
}];
export default class FontAwesomePreviewModal extends Modal {
  className() {
    return 'FontAwesomePreviewModal Modal--small';
  }
  title() {
    return app.translator.trans('core.admin.advanced.fontawesome.preview.label');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "helpText"
    }, app.translator.trans('core.admin.advanced.fontawesome.preview.help')), m("div", {
      className: "FontAwesomePreview"
    }, previewGroups.map(group => m("div", {
      className: "FontAwesomePreview-group"
    }, m("div", {
      className: "FontAwesomePreview-groupHeader"
    }, m("span", {
      className: "FontAwesomePreview-groupLabel"
    }, app.translator.trans(group.labelKey)), m("span", {
      className: "FontAwesomePreview-groupDivider"
    })), m("div", {
      className: "FontAwesomePreview-icons"
    }, group.icons.map(icon => m("div", {
      className: "FontAwesomePreview-tile",
      title: icon.cls
    }, m("span", {
      className: "FontAwesomePreview-icon"
    }, m("i", {
      className: icon.cls,
      "aria-hidden": "true"
    })), m("span", {
      className: "FontAwesomePreview-iconLabel"
    }, icon.label))))))));
  }
}
flarum.reg.add('core', 'admin/components/FontAwesomePreviewModal', FontAwesomePreviewModal);